export const featuredArticles = [
  {
    id: 1,
    title: 'The Rise of Generative AI: Transforming Creative Industries',
    excerpt: 'Explore how generative AI models like GPT-4 and DALL-E are revolutionizing content creation, design, and artistic expression across multiple industries.',
    category: 'ai',
    author: 'Dr. Sarah Mitchell',
    date: 'Jan 15, 2024',
    readTime: '8 min read',
    image: 'https://public.readdy.ai/ai/img_res/8661499e62d021744787d27708c061d6.jpg'
  },
  {
    id: 2,
    title: 'Blockchain Beyond Cryptocurrency: Real-World Applications',
    excerpt: 'Discover how blockchain technology is being applied in supply chain management, healthcare, voting systems, and digital identity verification.',
    category: 'blockchain',
    author: 'Marcus Chen',
    date: 'Jan 14, 2024',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=abstract%20blockchain%20network%20with%20interconnected%20orange%20glowing%20blocks%20and%20chains%20on%20minimalist%20white%20background%20representing%20decentralized%20technology%20and%20distributed%20ledger%20systems&width=800&height=600&seq=article-blockchain-001&orientation=landscape'
  },
  {
    id: 3,
    title: 'Quantum Computing: Breaking the Classical Barrier',
    excerpt: 'An in-depth look at recent quantum computing breakthroughs and their potential to solve complex problems in cryptography, drug discovery, and optimization.',
    category: 'quantum',
    author: 'Dr. Emily Zhang',
    date: 'Jan 13, 2024',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=quantum%20computing%20visualization%20with%20abstract%20orange%20and%20amber%20quantum%20particles%20and%20wave%20patterns%20on%20clean%20white%20background%20representing%20quantum%20mechanics%20and%20computational%20power&width=800&height=600&seq=article-quantum-001&orientation=landscape'
  },
  {
    id: 4,
    title: 'IoT Security: Protecting the Connected World',
    excerpt: 'Learn about the latest security challenges in IoT ecosystems and best practices for securing smart devices, industrial systems, and connected infrastructure.',
    category: 'iot',
    author: 'James Rodriguez',
    date: 'Jan 12, 2024',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=internet%20of%20things%20network%20with%20connected%20smart%20devices%20and%20orange%20glowing%20wireless%20signals%20on%20white%20background%20representing%20IoT%20ecosystem%20and%20device%20connectivity&width=800&height=600&seq=article-iot-001&orientation=landscape'
  },
  {
    id: 5,
    title: 'Zero Trust Architecture: The Future of Cybersecurity',
    excerpt: 'Understanding zero trust security models and how organizations are implementing them to protect against modern cyber threats and data breaches.',
    category: 'cybersecurity',
    author: 'Lisa Anderson',
    date: 'Jan 11, 2024',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=cybersecurity%20shield%20with%20orange%20glowing%20protection%20layers%20and%20digital%20lock%20symbols%20on%20clean%20white%20background%20representing%20zero%20trust%20security%20and%20data%20protection&width=800&height=600&seq=article-security-001&orientation=landscape'
  },
  {
    id: 6,
    title: 'Metaverse Development: Building Virtual Worlds',
    excerpt: 'Explore the technologies powering the metaverse, from VR/AR hardware to spatial computing platforms and decentralized virtual economies.',
    category: 'ar-vr',
    author: 'David Kim',
    date: 'Jan 10, 2024',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=virtual%20reality%20metaverse%20environment%20with%20orange%20and%20amber%20glowing%20digital%20landscapes%20and%20VR%20headset%20elements%20on%20white%20background%20representing%20immersive%20technology%20and%20virtual%20worlds&width=800&height=600&seq=article-vr-001&orientation=landscape'
  }
];

export const latestArticles = [
  {
    id: 7,
    title: 'Machine Learning Operations: Scaling AI in Production',
    excerpt: 'Best practices for deploying, monitoring, and maintaining machine learning models in production environments with MLOps frameworks and tools.',
    category: 'ai',
    author: 'Dr. Rachel Green',
    date: 'Jan 9, 2024',
    readTime: '13 min read',
    views: '12.5K',
    image: 'https://readdy.ai/api/search-image?query=machine%20learning%20operations%20dashboard%20with%20orange%20data%20pipelines%20and%20AI%20model%20monitoring%20graphs%20on%20clean%20white%20background%20representing%20MLOps%20and%20production%20AI%20systems&width=800&height=500&seq=article-mlops-001&orientation=landscape'
  },
  {
    id: 8,
    title: 'Smart Contracts: Automating Trust in Digital Transactions',
    excerpt: 'How smart contracts are revolutionizing business processes, reducing intermediaries, and enabling programmable money in decentralized finance.',
    category: 'blockchain',
    author: 'Alex Thompson',
    date: 'Jan 8, 2024',
    readTime: '9 min read',
    views: '10.2K',
    image: 'https://readdy.ai/api/search-image?query=smart%20contract%20code%20visualization%20with%20orange%20glowing%20digital%20agreements%20and%20blockchain%20transactions%20on%20white%20background%20representing%20automated%20trust%20and%20DeFi%20technology&width=800&height=500&seq=article-smartcontract-001&orientation=landscape'
  },
  {
    id: 9,
    title: 'Edge Computing: Processing Data at the Source',
    excerpt: 'The shift from cloud to edge computing and its impact on latency, bandwidth, and real-time processing for IoT and autonomous systems.',
    category: 'iot',
    author: 'Michael Brown',
    date: 'Jan 7, 2024',
    readTime: '10 min read',
    views: '9.8K',
    image: 'https://readdy.ai/api/search-image?query=edge%20computing%20network%20with%20distributed%20orange%20nodes%20and%20data%20processing%20at%20device%20level%20on%20white%20background%20representing%20decentralized%20computing%20and%20low%20latency%20systems&width=800&height=500&seq=article-edge-001&orientation=landscape'
  },
  {
    id: 10,
    title: 'Ransomware Defense: Strategies for 2024',
    excerpt: 'Latest ransomware trends and comprehensive defense strategies including backup solutions, network segmentation, and incident response planning.',
    category: 'cybersecurity',
    author: 'Jennifer Lee',
    date: 'Jan 6, 2024',
    readTime: '11 min read',
    views: '15.3K',
    image: 'https://readdy.ai/api/search-image?query=ransomware%20defense%20visualization%20with%20orange%20security%20barriers%20blocking%20malware%20attacks%20on%20white%20background%20representing%20cybersecurity%20protection%20and%20threat%20prevention&width=800&height=500&seq=article-ransomware-001&orientation=landscape'
  },
  {
    id: 11,
    title: 'Spatial Computing: The Next Interface Revolution',
    excerpt: 'How spatial computing is merging physical and digital worlds through advanced AR, VR, and mixed reality technologies for intuitive interactions.',
    category: 'ar-vr',
    author: 'Chris Martinez',
    date: 'Jan 5, 2024',
    readTime: '12 min read',
    views: '11.7K',
    image: 'https://readdy.ai/api/search-image?query=spatial%20computing%20interface%20with%20orange%20holographic%20elements%20and%20gesture%20controls%20on%20white%20background%20representing%20mixed%20reality%20and%20natural%20user%20interfaces&width=800&height=500&seq=article-spatial-001&orientation=landscape'
  },
  {
    id: 12,
    title: 'Quantum Cryptography: Unbreakable Security',
    excerpt: 'Understanding quantum key distribution and how quantum mechanics principles are creating theoretically unbreakable encryption methods.',
    category: 'quantum',
    author: 'Dr. Patricia Wilson',
    date: 'Jan 4, 2024',
    readTime: '14 min read',
    views: '8.9K',
    image: 'https://readdy.ai/api/search-image?query=quantum%20cryptography%20visualization%20with%20orange%20quantum%20entangled%20particles%20and%20secure%20key%20distribution%20on%20white%20background%20representing%20unbreakable%20encryption%20and%20quantum%20security&width=800&height=500&seq=article-quantumcrypto-001&orientation=landscape'
  }
];

export const articles = [...featuredArticles, ...latestArticles];
